import React from 'react'

export const ContrastAssess = () => (
  <svg
    width="68px"
    height="70px"
    viewBox="0 0 68 70"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="contrast-protect-icon"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-687.000000, -1452.000000)" stroke="#fff" strokeWidth="4">
        <g transform="translate(687.000000, 1452.000000)">
          <path d="M49.2530758,35.3204819 C49.2530758,52.4983133 42.2936852,66.4240964 33.7092428,66.4240964 C25.1215437,66.4240964 18.1621531,52.4983133 18.1621531,35.3204819 C18.1621531,18.1426506 25.1215437,4.21686747 33.7092428,4.21686747 C42.2936852,4.21686747 49.2530758,18.1426506 49.2530758,35.3204819 Z M63.7124554,35.3204819 C63.7124554,52.4983133 50.2789102,66.4240964 33.7092428,66.4240964 C17.1363188,66.4240964 3.70277355,52.4983133 3.70277355,35.3204819 C3.70277355,18.1426506 17.1363188,4.21686747 33.7092428,4.21686747 C50.2789102,4.21686747 63.7124554,18.1426506 63.7124554,35.3204819 Z M33.7092428,51.4221687 C17.1265489,51.4221687 3.68323385,44.213012 3.68323385,35.3204819 C3.68323385,26.4279518 17.1265489,19.2187952 33.7092428,19.2187952 C50.2919366,19.2187952 63.7319951,26.4279518 63.7319951,35.3204819 C63.7319951,44.213012 50.2919366,51.4221687 33.7092428,51.4221687 Z M33.494306,4.21686747 L33.494306,66.2014458 L33.494306,4.21686747 Z M3.25661702,35.1012048 L63.9469318,35.1012048 L3.25661702,35.1012048 Z"></path>
        </g>
      </g>
    </g>
  </svg>
)
